import React from 'react';
import {bool, func, object} from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import BasicModal from "../common/BasicModal";
import ErrorDisplay from "../common/ErrorDisplay";
import ResourceForm from 'components/forms/ResourceForm';
import BasicComponents from "components/forms/Component Sets/BasicFormComponents";
import {clone} from "../../utils/DBUtils";

const CreateBreakComponents = clone(BasicComponents);

export default class CreateBreakFormModal extends React.Component {
  static propTypes = {
    onValueChanged: func.isRequired,
    formConfig: object.isRequired,
    formData: object.isRequired,
    submit: func.isRequired,
    creationError: object,
    handleClose: func.isRequired,
    modalOpen: bool.isRequired
  };

  onValueChanged = (resourcePath, fieldPath, value) => {
    this.props.onValueChanged({
      [fieldPath.join('')]: value
    });
  };

  render() {
    return (
      <BasicModal
        header="Create a new break"
        specialType="primary-modal db-create-break-modal fadeInUp animResponse"
        dimmer='inverted'
        modalSize="small"
        actions={[
          {
            label: "Cancel",
            action: this.props.handleClose,
            isDisabled: false,
            displayType: "menu-item"
          },
          {
            label: "Create new break",
            action: () => this.props.submit(this.props.formData),
            isDisabled: this.props.creationError || isEmpty(this.props.formData.permalink),
            displayType: "button",
            primaryCheck: true
          }
        ]}
        open={this.props.modalOpen}
        onClose={this.props.handleClose}>
        <ResourceForm
          components={CreateBreakComponents}
          config={this.props.formConfig}
          resource={this.props.formData}
          onValueChanged={this.onValueChanged} />
        <ErrorDisplay error={this.props.creationError} />
      </BasicModal>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/break/CreateBreakFormModal.jsx